import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBackward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBackward"><Path fillRule="evenodd" clipRule="evenodd" d="M21.9999 4H5.5827L0.617188 12L5.5827 20H21.9999V4ZM10.5 8.68934L9.43934 9.75L11.6893 12L9.43934 14.25L10.5 15.3107L12.75 13.0607L15 15.3107L16.0607 14.25L13.8107 12L16.0607 9.75L15 8.68934L12.75 10.9393L10.5 8.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBackward;
